export const authState = {
    johnDeereApi: {
        accessToken: "JohnDeereApi.AccessToken",
        selectOrganizations: "JohnDeereApi.SelectOrganizations",
    },
};
